export default __webpack_public_path__ + "static/media/230-spain.74db9a8b.svg";